import useToken from '../../../hooks/useToken';
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, Row, Spinner, Badge } from 'react-bootstrap';
import { FiMail, FiCalendar, FiCamera, FiLoader, FiSave, FiLock, FiUsers, FiMapPin, FiRefreshCw, FiX, FiPhone } from 'react-icons/fi';
import IconButton from 'components/common/IconButton';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import SeccionArchivosEmpleados from './SeccionArchivosEmpleados';

const RegistroEmpleado = (
    empleado
) => {
    const location = useLocation();
    const { token, setToken } = useToken();
    const navigate = useNavigate();
    const { showErrorToast, showSuccessToast } = useToast();
    const [tipoUsuario, setTipoUsuario] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [editando, setEditando] = useState(location.state?.modoEdicionInicial || false);
    const [activo, setActivo] = useState('');
    const [arrastrarImagen, setArrastrarImagen] = useState(false);
    const [imagen, setImagen] = useState({
        file: null,
        fileName: ''
    });
    const [imagenRestaurar, setImagenRestaurar] = useState({
        file: null,
        fileName: ''
    });
    const [mostrarMensajeImagen, setMostrarMensajeImagen] = useState(false);
    const [usuario, setUsuario] = useState({
        idUsuario: 0,
        vUsuario: '',
        vContrasena: '',
        idCatTipoUsuario: '',
        vNombre: '',
        vApellidos: '',
        vCURP: '',
        vFoto: '',
        vImageName: '',
        dFechaNacimiento: '',
        vDomicilioPersonal: '',
        vDatosContactoPersonal: '',
        vTelefonoTrabajo: '',
        vEmailTrabajo: '',
        dFechaIngreso: '',
        iCategoria: '',
        bIsActive: '',
    });

    // Función para formatear fecha en formato día-mes(3 letras)-año
    const formatearFecha = (fechaISO) => {
        if (!fechaISO) return '';
 
        try {
            const fecha = new Date(fechaISO);
            const dia = fecha.getDate();
            const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const mes = meses[fecha.getMonth()];
            const año = fecha.getFullYear();
            
            return `${dia}-${mes}-${año}`;
        } catch (error) {
            return '';
        }
    };

    //Se carga la primera vez
    useEffect(() => {
        validarEmpleado();
        obtenerTipoUsuario();
    }, []);

    //Funcion para validar entre si es un usuario nuevo o un usuario a editar
    const validarEmpleado = async () => {
        //setCargando(true)
        if (empleado?.empleado) {
            setUsuario(empleado.empleado);
            setActivo(empleado.empleado.bIsActive ? "1" : "0");
            // Actualizar el estado de la imagen con los datos del empleado
            setImagen({
                file: empleado.empleado.vFoto,       // Base64 de la imagen
                fileName: empleado.empleado.vImageName // Nombre del archivo
            });
        }
    }

    //Funcion para modificar el valor de state usuario mediane values
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUsuario({ ...usuario, [name]: value });
    };
    const handleClose = () => {
        navigate('/contabilidad/empleados/lista');
    };
    /**
     * 
     * Funcion para obtener LOS TIPOS DE USUARIO
     */
    const obtenerTipoUsuario = async () => {
        const response = await fetch("/api/usuario/ObtenerTipoUsuario",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });
        if (response.ok) {
            console.log("==== OBTENER TIPO USUARIO ====");
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetalles:", ObjDetalles);
                setTipoUsuario(ObjDetalles.table2);
                console.log("USUARIO:", ObjDetalles.table2);
            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };
    //Funcion para guardar un nuevo usuario
    const guardarUsuario = async (e) => {
        e.preventDefault();
        setGuardando(true)
        const data = {
            //datos a enviar
            idUsuario: usuario.idUsuario || 0,
            vUsuario: usuario.vUsuario,
            vContrasena: usuario.vContrasena,
            idCatTipoUsuario: usuario.idCatTipoUsuario,
            vNombre: usuario.vNombre,
            vApellidos: usuario.vApellidos,
            vCURP: usuario.vCURP,
            dFechaNacimiento: usuario.dFechaNacimiento,
            vFoto: imagen.file,
            vDomicilioPersonal: usuario.vDomicilioPersonal,
            vDatosContactoPersonal: usuario.vDatosContactoPersonal,
            vTelefonoTrabajo: usuario.vTelefonoTrabajo,
            vEmailTrabajo: usuario.vEmailTrabajo,
            vImageName: imagen.fileName,
            dFechaIngreso: usuario.dFechaIngreso,
            iCategoria: usuario.iCategoria,
            bIsActive: activo
        };
        console.log("Enviando datos:", data);
        try {
            const response = await fetch("/api/usuario/GuardarActualizarUsuario", {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                const objResponse = await response.json();
                if (objResponse.iResponseType == 1) {
                    setCargando(false);
                    showSuccessToast("Usuario guardado correctamente");
                    navigate("/contabilidad/empleados/lista");
                } else {
                    showErrorToast(objResponse.vMessage);
                }
                setGuardando(false)
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.error("Error de conexión", error);
            showErrorToast("Error de conexión: " + error.message);
            setToken(null);
            setGuardando(false)
        }
        setCargando(false)
    };
    //Generar contraseña automatica segura 
    const GenerarContrasena = async (action) => {
        const response = await fetch("/api/usuario/GenerarContrasena", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });
        if (response.ok) {
            const data = await response.text();
            console.log(data);
            if (action == 'Contrasena') {
                setUsuario((prevUsuario) => ({
                    ...prevUsuario,          // Copia todos los campos existentes
                    vContrasena: data,       // Sobrescribe solo el campo vContrasena
                }));
            } else {
                setUsuario((prevUsuario) => ({
                    ...prevUsuario,          // Copia todos los campos existentes
                    vContrasena: data,       // Sobrescribe solo el campo vContrasena
                }));
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                navigate("");
            }
        }
    };
    // Selecciona el archivo de imagen
    const seleccionarImagen = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validar tipo de archivo
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                console.error("Formatos permitidos: JPG, PNG");
                showErrorToast("Solo se permiten archivos JPG y PNG.");
                return;
            }
            // Validar tamaño del archivo (2 MB = 2 * 1024 * 1024 bytes)
            const MAX_FILE_SIZE = 2 * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE) {
                console.error("Tamaño excedido");
                showErrorToast("El tamano maximo permitido es 2MB.");
                return;
            }
            // Validar extensión del archivo (case insensitive)
            const validExtensions = ['.jpg', '.jpeg', '.png'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                console.error("Extensiones permitidas: .jpg, .jpeg, .png");
                showErrorToast("Extensión no válida. Use JPG o PNG.");
                return;
            }
            // Si todas las validaciones son correctas, procesar el archivo
            procesarArchivo(file, setImagen);
        }
    };
    // Manejar arrastrar imagenes
    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragover" || e.type === "dragenter") {
            setArrastrarImagen(true);
        } else if (e.type === "dragleave") {
            setArrastrarImagen(false);
        }
    }, []);
    // Manejar soltar imagenes
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setArrastrarImagen(false);
        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            seleccionarImagen({ target: { files } }); // Reutilizamos la misma función del input
        }
    }, [seleccionarImagen]);
    //Procesa la imagen seleccionada
    const procesarArchivo = (file, setArchivo) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const base64String = event.target.result.split(",")[1];
            setArchivo({
                fileName: file.name,
                file: base64String
            });
            console.log("ARCHIVO Y NOMBRE", { fileName: file.name, file: base64String }); // Para depuración
        };
        reader.onerror = () => {
            console.error("Error al leer el archivo.");
        };
        reader.readAsDataURL(file);
    };
    //Funcion para borrar imagen
    const borrarImagen = () => {
        // Limpiar estados principales
        setImagen(prev => ({
            ...prev,
            file: '',
            fileName: null
        }));
        // Limpiar estado de previsualización
        setImagen({ file: null });
        // Resetear input de archivo
        const fileInput = document.getElementById('formFoto');
        if (fileInput) fileInput.value = '';
    };
    console.log("VALIDACIÓN:", {
        usuario: !!usuario.vUsuario,
        nombre: !!usuario.vNombre,
        pass: !!usuario.vContrasena,
        tipo: !!usuario.idCatTipoUsuario,
        cat: !!usuario.iCategoria,
        fecha: !!usuario.dFechaNacimiento,
        activo: activo !== ''
    });
    return (
        <>
            {!cargando ?
                <>
                    <Card className="mb-2">
                        <Card.Header className="d-flex align-items-center ">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                                className="me-2"
                            />
                            {/* Contenedor central (ocupa espacio restante) */}
                            <div className="d-flex align-items-center justify-content-center flex-grow-1">
                                <img
                                    src="/img/team/nofoto50.png"
                                    alt="connectCircle"
                                    height={40}
                                    className="me-2"
                                />
                                <h3 style={{ lineHeight: '1', marginBottom: -6 }}>
                                    {empleado.empleado ? usuario.vNombre + ' ' + usuario.vApellidos : 'Registro de nuevo Empleado'}
                                </h3>
                            </div>
                            
                            <Button
                                variant={editando ? "outline-secondary" : "primary"}
                                onClick={() => {
                                    if (!editando) {
                                        // Guardar respaldo ANTES de entrar en modo edición
                                        setImagenRestaurar({
                                            file: imagen.file,
                                            fileName: imagen.fileName
                                        });
                                    } else {
                                        // RESTAURAR el respaldo al cancelar edición
                                        setImagen({
                                            file: imagenRestaurar.file,
                                            fileName: imagenRestaurar.fileName
                                        });
                                    }
                                    setEditando(!editando);
                                }}
                            >
                                {editando ? (
                                    <><FiX className="me-2" /> Cancelar Edición</>
                                ) : (
                                    <><FiRefreshCw className="me-2" /> Editar Información</>
                                )}
                            </Button>
                        </Card.Header>
                    </Card>

                    <Card className="shadow-sm border-0"
                        style={{
                            borderRadius: '15px',
                            overflow: 'hidden'
                        }}>
                        <Card.Body className="p-3">
                            {/* align-items-start elimina el espacio blanco arriba de la foto */}
                            <Row className="align-items-start g-0">

                                <Col md={3} className="text-center mb-0 p-0">
                                    <Form.Group className="m-0">
                                        <div className="position-relative d-inline-block" style={{ width: '130px' }}>
                                            <div style={{
                                                width: '100%',
                                                aspectRatio: '3/4',
                                                borderRadius: '12px',
                                                border: arrastrarImagen ? '2px dashed #007bff' : '1px solid #ddd',
                                                backgroundColor: '#f8f9fa',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                                onDragOver={editando ? handleDrag : undefined}
                                                onDragEnter={editando ? handleDrag : undefined}
                                                onDragLeave={editando ? handleDrag : undefined}
                                                onDrop={editando ? handleDrop : undefined}>

                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={seleccionarImagen}
                                                    style={{ display: 'none' }}
                                                    id="fileInput" />

                                                <label
                                                    htmlFor={editando ? "fileInput" : undefined}
                                                    className={`w-100 h-100 m-0 d-flex align-items-center justify-content-center ${editando ? 'cursor-pointer' : ''}`}
                                                    style={{ cursor: editando ? 'pointer' : 'default' }}

                                                    onMouseEnter={(e) => {
                                                        if (editando && !imagen?.file) {
                                                            e.currentTarget.style.backgroundColor = '#e7f3ff';
                                                            e.currentTarget.style.borderColor = '#007bff';
                                                            setMostrarMensajeImagen(true);

                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (editando && !imagen?.file) {
                                                            e.currentTarget.style.backgroundColor = '';
                                                            e.currentTarget.style.borderColor = '';
                                                            setMostrarMensajeImagen(false);

                                                        }
                                                    }}>

                                                    {imagen?.file ? (
                                                        <img
                                                            src={`data:image/jpeg;base64,${imagen.file}`}
                                                            alt="Profile"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    ) : (
                                                        <div className="text-center">
                                                            <FiCamera size={30} className="text-primary mb-2" />
                                                                <div className="small fw-bold text-primary">FOTO</div>
                                                                {editando && mostrarMensajeImagen && (
                                                                    <div className="small text-muted mt-1" style={{ fontSize: '10px' }}>
                                                                        Selecciona una imagen
                                                                    </div>
                                                                )}
                                                        </div>
                                                    )}
                                                </label>

                                                {imagen?.file && editando && (
                                                    <button
                                                        type="button"
                                                        onClick={borrarImagen}
                                                        className="btn-close position-absolute top-0 end-0 m-2 bg-danger text-white rounded-circle"
                                                        style={{ padding: '5px', fontSize: '10px' }}>
                                                        </button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2 w-100">
                                            <div className="fw-bold text-uppercase text-dark lh-sm" style={{ fontSize: '13px', letterSpacing: '0.5px' }}>
                                                {usuario.vNombre}
                                            </div>
                                            <div className="text-primary fw-semibold mt-1" style={{ fontSize: '11px' }}>
                                                {tipoUsuario.find(t => t.idCatTipoUsuario === usuario.idCatTipoUsuario)?.vNombreTipoUsuario || 'Sin Tipo'}
                                            </div>
                                        </div>
                                        
                                        
                                    </Form.Group>

                                </Col>

                                {/* COLUMNA DERECHA: Datos del Empleado */}
                                <Col md={9} className="ps-3">
                                    <Row className="g-2">
                                        {/* --- SECCIÓN: DATOS PERSONALES --- */}
                                        <Col xs={6}>
                                            <h6 className="text-primary mb-2 d-flex align-items-center" style={{ fontSize: '14px' }}>
                                                <div style={{ width: '3px', height: '15px', backgroundColor: '#007bff', marginRight: '6px', borderRadius: '2px' }}></div>
                                                Datos Personales del empleado
                                            </h6>
                                        </Col>
                                        <Col xs={6}>
                                            <h6 className="text-primary mb-2 d-flex align-items-center" style={{ fontSize: '14px' }}>
                                                <div style={{ width: '3px', height: '15px', backgroundColor: '#007bff', marginRight: '6px', borderRadius: '2px' }}></div>
                                                Configuración del Sistema
                                            </h6>
                                        </Col>

                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Nombre Completo</label>
                                          
                                            {
                                                editando ? (
                                                    <>
                                                        <Form.Control size="sm" name="vNombre" value={usuario.vNombre ?? ''} onChange={handleChange} placeholder="Nombre(s)" className="mb-1" />
                                                        <Form.Control size="sm" name="vApellidos" value={usuario.vApellidos ?? ''} onChange={handleChange} placeholder="Apellidos" />
                                                    </>
                                                ): (
                                                        <span className="d-block small text-dark">{usuario.vNombre} {usuario.vApellidos}</span>               

                                                )
                                            }
                                        </Col>
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Tipo de Usuario</label>
                                            {editando ? (
                                                <Form.Select size="sm" value={usuario.idCatTipoUsuario} onChange={(e) => setUsuario({ ...usuario, idCatTipoUsuario: Number(e.target.value) })}>
                                                    {tipoUsuario.map(t =><option key={t.idCatTipoUsuario} value={t.idCatTipoUsuario}>{t.vNombreTipoUsuario}</option>)}
                                                </Form.Select>
                                            ) : (
                                                <span className="fw-bold small"><FiUsers className="me-1 text-primary" /> {tipoUsuario.find(t => t.idCatTipoUsuario === usuario.idCatTipoUsuario)?.vNombreTipoUsuario}</span>
                                            )}
                                        </Col>

                                        
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">CURP</label>
                                            {editando ? (
                                                <Form.Control size="sm" name="vCURP" value={usuario.vCURP ?? ''} onChange={handleChange} />
                                            ) : (
                                                <span className="small text-dark">{usuario.vCURP}</span>
                                            )}
                                        </Col>
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Categoría</label>
                                            {editando ? (
                                                <Form.Select size="sm" name="iCategoria" value={usuario.iCategoria} onChange={handleChange}>
                                                    <option value="">Selecciona una categoria...</option>
                                                    <option value="1">Empleado</option>
                                                    <option value="2">Hon. Prof</option>
                                                    <option value="3">Residente</option>
                                                    <option value="4">Becario</option>
                                                </Form.Select>
                                            ) : (

                                                    <Badge bg={usuario.iCategoria == "1" ? "soft-primary" : usuario.iCategoria == "2" ? "soft-danger" : usuario.iCategoria == "3" ? "soft-warning" : "soft-success"}
                                                        className={usuario.iCategoria == "1" ? "text-primary fs--1" : usuario.iCategoria == "2" ? "text-danger fs--1" : usuario.iCategoria == "3" ? "text-warning fs--1" : "text-success fs--1"}>
                                                        {usuario.iCategoria == "1" ? "EMPLEADO" : usuario.iCategoria == "2" ? "Hon. Prof" : usuario.iCategoria == "3" ? "RESIDENTE" : "BECARIO"}
                                                    </Badge>
                                            )}
                                        </Col>

                                        
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Fecha de Nacimiento</label>
                                            {editando ? (
                                                <DatePicker
                                                    selected={usuario.dFechaNacimiento ? new Date(usuario.dFechaNacimiento) : null}
                                                    onChange={(date) => {
                                                        console.log(date);
                                                        setUsuario({ ...usuario, dFechaNacimiento: date ? date.toISOString() : '' });
                                                    }}
                                                    dateFormat="d-MMM-yyyy"  // Formato: día/mes/año
                                                    className="form-control form-control-sm w-100"
                                                    placeholderText="Seleccione fecha de nacimiento"
                                                    showMonthYearPicker

                                                />
                                                ) : (
                                                    <span className="small text-dark">
                                                    <FiCalendar className="me-2 text-warning" />
                                                    {formatearFecha(usuario.dFechaNacimiento)}
                                                    </span>
                                            )}
                                        </Col>
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Estado</label>
                                            {editando ? (
                                                <Form.Select as="select" size="sm" value={activo ?? ''} onChange={(e) => setActivo(e.target.value)}>
                                                    <option value="">Seleccione un estado...</option>
                                                    <option value="1">✅ Activo</option>
                                                    <option value="0">❌ Inactivo</option>
                                                </Form.Select>
                                            ) : (
                                                    <Badge bg={activo === "1" ? "success" : activo === "0" ? "danger" : "secondary"} 
                                                           className="fs--1">
                                                            {activo === "1" ? "ACTIVO" : activo === "0" ? "INACTIVO" : "Sin definir"}
                                                    </Badge>
                                            )}
                                        </Col>
                                        <Col sm={6}>
                                            <label className="text-muted small fw-bold d-block text-uppercase mb-0">Domicilio</label>
                                            {editando ? (
                                                <Form.Control size="sm" name="vDomicilioPersonal" value={usuario.vDomicilioPersonal ?? ''} onChange={handleChange} />
                                            ) : (
                                                <span className="small text-muted text-truncate d-block" style={{ fontSize: '11px' }}>
                                                    <FiMapPin size={12} className="me-1 text-danger" /> {usuario.vDomicilioPersonal}
                                                </span>
                                            )}
                                        </Col>

                                       {/* --- SECCIÓN: CONTACTO LABORAL --- */}
                                        <Col xs={12} className="mt-2">
                                            
                                            <Row className="g-2">
                                                <Col xs={6}>
                                                    <h6 className="text-primary mb-2 d-flex align-items-center" style={{ fontSize: '14px' }}>
                                                        <div style={{ width: '3px', height: '15px', backgroundColor: '#007bff', marginRight: '6px', borderRadius: '2px' }}></div>
                                                        Informacion de Contacto Laboral
                                                    </h6>
                                                </Col>
                                                <Col xs={6}>
                                                    <h6 className="text-primary mb-2 d-flex align-items-center" style={{ fontSize: '14px' }}>
                                                        <div style={{ width: '3px', height: '15px', backgroundColor: '#007bff', marginRight: '6px', borderRadius: '2px' }}></div>
                                                        Credenciales de Acceso
                                                    </h6>
                                                </Col>
                                                <Col sm={6}>
                                                    <label className="text-muted small fw-bold d-block text-uppercase mb-0" style={{ fontSize: '10px' }}>
                                                        <FiPhone className="me-1 text-primary" /> Teléfono
                                                    </label>
                                                    {editando ? (
                                                        <Form.Control size="sm" name="vTelefonoTrabajo" value={usuario.vTelefonoTrabajo ?? ''} onChange={handleChange} />
                                                    ) : (
                                                        <span className="small text-dark">{usuario.vTelefonoTrabajo}</span>
                                                    )}
                                                </Col>
                                                <Col sm={6}>
                                                    <small className="text-muted d-block" style={{ fontSize: '10px' }}>Usuario:</small>
                                                    {editando ? (
                                                        <div className="d-flex gap-1 align-items-center">
                                                            <Form.Control size="sm" name="vUsuario" value={usuario.vUsuario ?? ''} onChange={handleChange} />

                                                        </div>
                                                    ) : (
                                                        <strong className="text-dark small"><FiMail size={12} className="me-1 text-info" /> {usuario.vUsuario}</strong>
                                                    )}
                                                </Col>
                                                <Col sm={6}>
                                                    <label className="text-muted small fw-bold d-block text-uppercase mb-0" style={{ fontSize: '10px' }}>
                                                        <FiMail className="me-1 text-success" /> Email Laboral
                                                    </label>
                                                    {editando ? (
                                                        <Form.Control size="sm" type="email" name="vEmailTrabajo" value={usuario.vEmailTrabajo ?? ''} onChange={handleChange} />
                                                    ) : (
                                                        <span className="small text-dark text-truncate d-block">{usuario.vEmailTrabajo}</span>
                                                    )}
                                                </Col>
                                                <Col sm={6}>
                                                    <Form.Group className="mb-3 g-2">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            {
                                                                editando &&
                                                                <Form.Label className="d-flex align-items-center mb-0">
                                                                    <FiLock className="me-2 text-secondary" />
                                                                    <small className="text-muted d-block" style={{ fontSize: '10px' }}>Contraseña:</small>
                                                                </Form.Label>
                                                            }

                                                            {
                                                                editando && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => { GenerarContrasena('Contrasena') }}
                                                                        style={{
                                                                            background: 'linear-gradient(135deg, #007bff, #0056b3)',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            borderRadius: '6px',
                                                                            padding: '6px 12px',
                                                                            cursor: 'pointer',
                                                                            fontSize: '12px',
                                                                            fontWeight: '600',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '4px',
                                                                            boxShadow: '0 2px 4px rgba(0,123,255,0.2)',
                                                                            transition: 'all 0.2s ease'
                                                                        }}
                                                                    >
                                                                        <FiRefreshCw size={12} />
                                                                        Generar
                                                                    </button>
                                                                )
                                                            }
                                                        </div>
                                                        {
                                                            editando ?
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    name="vContrasena"
                                                                    value={usuario.vContrasena ?? ''}
                                                                    onChange={handleChange}
                                                                    placeholder="Contraseña del usuario"

                                                                />
                                                                :
                                                                <>
                                                                    <FiLock className="me-2 text-secondary" />
                                                                    ********
                                                                </>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6}>
                                                    <label className="text-muted small fw-bold d-block text-uppercase mb-0" style={{ fontSize: '10px' }}>Fecha de Ingreso</label>
                                                    {editando ? (
                                                        <DatePicker
                                                            selected={usuario.dFechaIngreso ? new Date(usuario.dFechaIngreso) : null}
                                                            onChange={(date) => {
                                                                console.log(date);
                                                                setUsuario({ ...usuario, dFechaIngreso: date ? date.toISOString() : '' });
                                                            }}
                                                            dateFormat="d-MMM-yyyy"
                                                            className="form-control form-control-sm w-100"
                                                            showMonthYearPicker
                                                        />
                                                    ) : (
                                                        <span className="small text-dark">
                                                         <FiCalendar className="me-1 text-warning" />
                                                       {formatearFecha(usuario.dFechaIngreso)}
                                                        </span>
                                                    )}
                                                </Col>
                                                
                                                
                                            </Row>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mt-1">
                        {empleado?.empleado?.idUsuario && (
                            <SeccionArchivosEmpleados
                                idEmpleado={empleado.empleado.idUsuario}
                            />
                        )}
                        <Card.Footer className="bg-light border-top">
                            <Row className="d-flex justify-content-end align-items-center">
                                <Col xs="auto" className="d-flex gap-3">
                                    <Button
                                        type="button"
                                        onClick={handleClose}
                                        variant="outline-danger"
                                        className="px-4 py-2 d-flex align-items-center"
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = '#dc3545';
                                            e.target.style.color = 'white';
                                            e.target.style.borderColor = '#dc3545';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#dc3545';
                                            e.target.style.borderColor = '#dc3545';
                                        }}
                                    >
                                        <FiX className="me-2" size={16} />
                                        Cancelar
                                    </Button>
                                    {!guardando ? (
                                        <Button
                                            variant="primary"
                                            className="px-4 py-2 d-flex align-items-center"
                                            type="button"
                                            disabled={
                                                !usuario.vUsuario ||
                                                !usuario.vNombre ||
                                                !usuario.vContrasena ||
                                                !usuario.vApellidos ||
                                                !usuario.idCatTipoUsuario ||
                                                !usuario.dFechaNacimiento ||
                                                !usuario.vEmailTrabajo ||
                                                !usuario.dFechaIngreso ||
                                                !usuario.iCategoria ||    
                                                activo === ''               
                                            }
                                            onClick={guardarUsuario}
                                            style={{
                                                borderRadius: '8px',
                                                fontWeight: '600',
                                                background: 'linear-gradient(135deg, #007bff, #0056b3)',
                                                border: 'none',
                                                boxShadow: '0 2px 8px rgba(0,123,255,0.3)',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                        >
                                            <FiSave className="me-2" size={16} />
                                            Guardar
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="primary"
                                            className="px-4 py-2 d-flex align-items-center"
                                            type="submit"
                                            disabled
                                            onClick={guardarUsuario}
                                            style={{
                                                borderRadius: '8px',
                                                fontWeight: '600',
                                                background: '#6c757d',
                                                border: 'none'
                                            }}
                                        >
                                            <FiLoader className="me-2 spinner-border spinner-border-sm" size={16} />
                                            Guardando...
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </Card.Footer>
                    </Card>
                    
                </>
                :
                (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)
            }
            
            
        </>
    );
};
RegistroEmpleado.propTypes = {
    setEditando: PropTypes.bool,
    imagen: PropTypes.object
    
}
export default RegistroEmpleado;